/**
 * Phone number enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Phone number status labels
export const phoneNumberStatusLabels = {
    pending_registration: 'Pending Registration',
    active: 'Active',
    suspended: 'Suspended',
    releasing: 'Releasing',
    released: 'Released',
    failed: 'Failed',
};
export const phoneNumberStatusValues = Object.keys(phoneNumberStatusLabels);
// Phone number provider labels
export const phoneNumberProviderLabels = {
    telnyx: 'Telnyx',
    manual: 'Manual',
    twilio: 'Twilio',
};
export const phoneNumberProviderValues = Object.keys(phoneNumberProviderLabels);
// Voice receptionist numbers: a SHARED number serves many clinics (the call is
// routed by the line it was forwarded from); a DEDICATED one belongs to one.
export const voiceNumberAssignmentLabels = {
    shared: 'Shared',
    dedicated: 'Dedicated',
};
export const voiceNumberAssignmentValues = Object.keys(voiceNumberAssignmentLabels);
//# sourceMappingURL=phone-numbers.js.map